/**
 * Add time to current date with fallback to hours if unit is unknown
 * Accepted: "seconds", "minutes", "hours", "days"
 */
export function addToCurrentDate(value: number, unit: string): Date {
  const normalized = unit.toLowerCase();
  const now = new Date();

  // Convert to milliseconds
  let ms: number;
  switch (normalized) {
    case 'seconds':
      ms = value * 1000;
      break;
    case 'minutes':
      ms = value * 60_000;
      break;
    case 'days':
      ms = value * 60_000 * 60 * 24;
      break;

    case 'hours':
    default:
      // DEFAULT goes to HOURS
      ms = value * 60_000 * 60;
      break;
  }

  return new Date(now.getTime() + ms);
}

/**
 * Time left until `endAt`, split into days, hours and minutes.
 *
 * Minutes matter: a pass can be sold by the hour, and a days-and-hours readout
 * shows "0d 0h" for all but the first minute of one — indistinguishable from
 * expired. Returns `null` for a missing or unparseable date, and clamps to zero
 * once the period has passed.
 */
export function getRemainingTime(
  endAt?: string | null,
): { days: number; hours: number; minutes: number } | null {
  if (!endAt) return null;

  const end = new Date(endAt);
  if (Number.isNaN(end.getTime())) return null;

  const remainingMs = Math.max(end.getTime() - Date.now(), 0);
  const minutesTotal = Math.floor(remainingMs / 60_000);

  return {
    days: Math.floor(minutesTotal / 1_440),
    hours: Math.floor((minutesTotal % 1_440) / 60),
    minutes: minutesTotal % 60,
  };
}
